import React from 'react';
import {Button, Col} from 'antd';
import {fieldColProps} from '../gridHelpers';

const mapVariantToType = (variant?: string) => {
  if (variant === 'contained') return 'primary';
  if (variant === 'text') return 'text';
  return 'default';
};

export const CustomButton = (props) => {
  const buttonField = props.field;
  const customEvents: any = props.customEvents
    ? props.customEvents[buttonField.name] && props.customEvents[buttonField.name]
    : {};

  return (
    <Col {...fieldColProps(buttonField)}>
      <Button
        htmlType={buttonField.htmlInputType}
        type={mapVariantToType(buttonField.variant)}
        danger={buttonField.color === 'error'}
        name={buttonField.name}
        id={buttonField.id}
        block
        disabled={buttonField?.isDisabled || props?.formikProp?.isSubmitting}
        onClick={() => {
          props.formikProp.values.buttonAction = buttonField.fieldLabel;
          props.setSubmitting(false);
        }}
        {...customEvents}>
        {buttonField.fieldLabel}
      </Button>
    </Col>
  );
};
